import { createFileRoute } from '@tanstack/react-router';

import Content from '@/routes/_authenticated/hilfe/benutzerverwaltung.mdx';

export const Route = createFileRoute('/_authenticated/hilfe/benutzerverwaltung')({
  component: Content,
});
